import MyPathBanner from './MyPathBanner';

export default MyPathBanner;
